import { Circle, G, Path } from "@react-pdf/renderer";

type PdfClientIconProps = {
  x?: number;
  y?: number;
};

export const PdfClientIcon = ({ x = 0, y = 0 }: PdfClientIconProps) => {
  return (
    <G transform={`translate(${x}, ${y})`}>
      <Circle cx={8.33333} cy={8.33333} r={8.33333} fill="#0A1A53" />
      <Path
        d="M5.06037 9.37869C5.73948 9.37869 6.33446 9.01783 6.66851 8.47912C6.40705 8.05345 6.06808 7.2844 6.46707 6.22475C6.12019 5.83873 5.61906 5.59375 5.06037 5.59375C4.01689 5.59375 3.16797 6.44264 3.16797 7.48622C3.16797 8.52967 4.01689 9.37869 5.06037 9.37869Z"
        fill="#FBFCFF"
      />
      <Path
        d="M6.43102 9.05087C6.41469 9.06577 6.39771 9.08042 6.38086 9.09494C6.37256 9.10194 6.36414 9.10881 6.35584 9.11568C6.33277 9.13395 6.30425 9.15508 6.27275 9.17712C6.08738 9.66916 5.61373 10.0198 5.05686 10.0198C4.49558 10.0198 4.01869 9.66385 3.83644 9.16571C3.77746 9.12358 3.73235 9.08781 3.70603 9.0659C3.69657 9.05735 3.68646 9.0497 3.67713 9.04102L3.66092 9.05514C2.48288 10.0737 2.49883 10.7579 2.5 10.8332L3.08344 11.9998L5.49862 11.9951C5.54438 11.3042 5.74867 10.075 6.57413 9.16584C6.51437 9.11153 6.46395 9.07316 6.43102 9.05087Z"
        fill="#FBFCFF"
      />
      <Path
        d="M10.2423 8.9855C10.2234 9.00261 10.204 9.01933 10.1846 9.03592C10.1753 9.04409 10.1657 9.05186 10.1561 9.05977C9.97115 9.20702 9.54546 9.48402 8.98418 9.57281C8.92844 9.58046 8.87322 9.58927 8.81645 9.5929C8.76849 9.59576 8.72039 9.5977 8.67166 9.5977C8.49498 9.5977 8.32348 9.5767 8.15808 9.53924C7.6353 9.40612 7.23605 9.09788 7.1225 9.00287C7.11174 8.99315 7.10007 8.98446 7.08957 8.97461L7.07104 8.99068C5.72228 10.1569 5.74082 12.1979 5.74238 12.2842L5.74354 12.3566H11.5156L11.5125 12.28C11.4169 9.92188 10.4738 9.14208 10.2423 8.9855ZM9.43995 10.5827L8.62901 10.1693L7.81807 10.5827V9.57877L8.62901 10.0122L9.43995 9.57877V10.5827Z"
        fill="#FBFCFF"
      />
      <Path
        d="M8.67984 9.33609H8.68049C9.25862 9.33584 9.80265 9.11003 10.2125 8.70004C10.6224 8.28979 10.8482 7.74551 10.848 7.16753C10.8477 5.97255 9.87512 5 8.67984 5C7.48391 5.00039 6.51159 5.9732 6.51172 7.1687C6.51224 8.3638 7.48482 9.33609 8.67984 9.33609Z"
        fill="#FBFCFF"
      />
      <Path
        d="M13.0849 9.33191L13.0706 9.31934C13.0363 9.35109 13.0009 9.38142 12.9646 9.41046L12.212 10.8756L12.0784 10.0161L12.2928 9.66944C12.1562 9.70224 12.0137 9.72 11.8671 9.72C11.829 9.72 11.7911 9.71831 11.7536 9.71598C11.6847 9.7117 11.6169 9.7034 11.5503 9.69174C11.5242 9.68707 11.4983 9.68202 11.4727 9.67631L11.6838 10.0157L11.5432 10.8342C11.6565 11.2342 11.8083 11.7341 11.8324 11.999H13.5824L14.1657 10.8323C14.1669 10.7647 14.1433 10.2477 13.0849 9.33191Z"
        fill="#FBFCFF"
      />
      <Path
        d="M10.5039 8.69529C10.8055 9.171 11.3364 9.48753 11.94 9.48779C12.8775 9.48792 13.6407 8.72536 13.6408 7.78781C13.6411 6.85025 12.8786 6.08717 11.9409 6.08691C11.5594 6.08691 11.2066 6.2133 10.9225 6.42639C11.011 6.66969 11.0594 6.93218 11.0594 7.20568C11.0591 7.77471 10.8494 8.29501 10.5039 8.69529Z"
        fill="#FBFCFF"
      />
    </G>
  );
};
